import { Button } from "antd";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    background: ${({ theme }) => `${theme.dangerTypographyColor}30`};
    height: 24px;

    svg {
        font-size: 16px;
        color: ${({ theme }) => theme.dangerTypographyColor};
    }
`;
